<template>
  <nav class="navbar is-white" role="navigation">
    <div class="container">
      <div class="navbar-brand">
        <span class="navbar-item brand-text is-size-4">SX-Score Console</span>
        <div class="navbar-burger burger" @click="menuActive = !menuActive" :class="{ 'is-active' : menuActive }" data-target="navbarForNarrowed">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </div>
      </div>

      <div class="navbar-menu" :class="{ 'is-active' : menuActive }">
        <div class="navbar-start">
          <router-link class="navbar-item" :to="{name: 'scoring'}">スコアリング</router-link>
          <router-link class="navbar-item" :to="{name: 'results'}">スコアリング結果</router-link>
        </div>
        <div class="navbar-end">
          <a class="navbar-item has-dropdown is-hoverable">
            <a v-if="display_name" class="navbar-link">{{ display_name }} ＠ {{ company_name }} 様</a>
            <a v-else class="navbar-link">{{ company_name }} 様</a>
            <div class="navbar-dropdown is-boxed">
              <router-link class="navbar-item" :to="{name: 'account'}">アカウント</router-link>
              <router-link class="navbar-item" :to="{name: 'inquiry'}">お問い合わせ</router-link>
              <hr class="navbar-divider">
              <a class="navbar-item has-text-danger" @click="logout">ログアウト</a>
            </div>
          </a>
        </div>

      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      menuActive: false,
      display_name: '',
      company_name: ''
    }
  },
  created () {
    const user = this.$session.get('user')
    this.display_name = user.display_name
    this.company_name = user.company_name
  },
  methods: {
    logout () {
      this.$session.destroy()
      this.$router.push('/login')
    }
  }
}
</script>

<style>

  nav.navbar {
    /*border-top: 4px solid #276cda;*/
    margin-bottom: 3rem;
    color: #4b5a71;
  }

  .navbar-item.brand-text {
    font-weight: 300;
  }

  .navbar-item, .navbar-link {
    font-size: 14px;
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue